<template>
  <div class="cricket-coverage">
    <loading-state :state="state"></loading-state>
    <div v-if="coverage" >
      <div class="coverage-selected">
        <div class="item clickable" @click="toggleShowSelection()">{{coverageSelected.board | capitaliseUpper}}</div>
        <div class="item clickable" @click="toggleShowSelection()">{{coverageSelected.competition | capitaliseUpper}}</div>
        <div class="item clickable" @click="toggleShowSelection()">
          <span v-if="coverageSelected.year">{{coverageSelected.year}}</span>
          <span v-else>{{allYearText}}</span>
        </div>
        <div class="item clickable" @click="toggleShowSelection()" v-if="coverageSelected.vsTeam">vs {{coverageSelected.vsTeam | capitaliseUpper}}</div>
      </div>
      <div class="coverage-selection" v-if="showSelection">
        <div class="coverarge-tool" >
          <div class="item clickable" @click="updateSelection()">Update Selection</div>
        </div>
        <div class="coverage-list">
          <div class="boards">
            <ul>
              <li 
                v-for="board in coverage"
                :key="board.key"
                :class="{active:board.key == coverageSelected.board}"
                class="clickable"
                @click="coverage.selectBoard(board.key)">
                <div>{{board.name}}</div>
                <div class="meta">{{board.is_international?'International':'Local'}}. {{board.region}}</div>
              </li>
            </ul>
          </div>
          <div class="competitions">
            <ul>
              <li
                v-for="competition in coverage[coverageSelected.board].competitions"
                :key="competition.key"
                :class="{active:competition.key == coverageSelected.competition}"
                class="clickable"
                @click="coverage.selectCompetition(competition.key)">
                <div>{{competition.name}}</div>
                <div class="meta">
                  {{competition.is_international?'International':'Local'}}.
                  {{competition.possible_occurrence | capitalise}}.
                  Coverage {{competition.data_coverage_percentage}}%</div>
              </li>
            </ul>
          </div>
          <div class="year">
            <ul>
              <li
                :class="{active:coverageSelected.year == null}"
                class="clickable"
                @click="coverage.selectYear(null)">
                All Time
              </li>
              <li
                v-for="(year, key) in coverage[coverageSelected.board].competitions[coverageSelected.competition].years"
                :key="key"
                :class="{active:key == coverageSelected.year}"
                class="clickable"
                @click="coverage.selectYear(key)">
                <div>{{key}} ({{year.data_coverage_percentage}}%)</div>
                <div class="meta" v-if="year.note">{{year.note}}</div>
              </li>
            </ul>
          </div>
          <div class="vsteam" v-if="showVsTeam">
            <label >Vs Team</label>
            <input v-model="coverageSelected.vsTeam" type="text" placeholder="Team Key">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { DataState, AppState } from '@/state'
import { CricketCoverage } from '@/models/cricket/core'
export default {
  props: {
    showVsTeam: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      showSelection: false,
      coverage: null,
      coverageSelected: CricketCoverage.State.selected,
      state: DataState.newNotInit(),
    }
  },
  computed: {
    allYearText () {
      const years = this.coverage[this.coverageSelected.board].competitions[this.coverageSelected.competition].years
      const yearsList = Object.keys(years)
      if (yearsList.length > 1) {
        return `Years ${yearsList[0]} - ${yearsList[yearsList.length-1]}`
      }else if (yearsList.length == 1) {
        return yearsList[0]
      }
      return 'All Time'
    }
  },
  mounted () {
    if(!this.state.isLoading() && !CricketCoverage.State.coverage) {
      this.loadCoverage()
    }

    if (CricketCoverage.State.coverage && !this.coverage) {
      this.coverage = CricketCoverage.State.coverage
    }
  },
  methods: {
    loadCoverage () {
      this.state.changeToLoading()
      CricketCoverage.State.fetch().then((coverage) => {
        console.log('Loaded Coverage')
        this.coverage = coverage
        this.state.changeToLoaded()
      }).catch((error) => {
        console.error(error)
        this.state.changeToError(error)
      })
    },

    toggleShowSelection () {
      this.showSelection = !this.showSelection
    },

    updateSelection () {
      if(!this.coverageSelected.vsTeam) {
        this.coverageSelected.vsTeam = null
      }
      this.$emit('coverageSelected')
      this.showSelection = false
    }
  }
}
</script>
